import ExcelJS from "exceljs";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { customerApi } from "../apiConfig";

const PRODUCT_CONTROL_DEFS = [
  {
    key: "dis_gozetim",
    parameter: "DIŞ GÖZETİM",
    tolerance: "Müşteri adına gözetmeni",
    expectedValue: "VAR - YOK",
  },
  {
    key: "dolum_yeri",
    parameter: "DOLUM YERİ",
    tolerance: "Dolum yeri",
    expectedValue: "FABRİKA - DEPO",
  },
  {
    key: "bpr_uc_hasar",
    parameter: "B/P/R UÇ KISIMLARINDA HASAR",
    tolerance: "Boru - Profil 5 cm’lik kısım dikkate alınacak",
    expectedValue: "EZİLME - VURUK - ÇAPAK",
  },
  {
    key: "bpr_yuzey_durumu",
    parameter: "B/P/R YÜZEY DURUMU",
    tolerance: "Boru - Profil tüm boy dikkate alınacak",
    expectedValue: "PAS - LEKE - TOZ - KİRLİLİK",
  },
  {
    key: "kosebent_duzgunlugu",
    parameter: "KÖŞEBENT DÜZGÜNLÜĞÜ",
    tolerance: "Köşebent doğru noktada olup olmadığı",
    expectedValue: "UYGUN - UYGUN DEĞİL - YOK",
  },
  {
    key: "cember_sayisi_durumu",
    parameter: "ÇEMBER SAYISI ve DURUMU",
    tolerance:
      "1 metre ara ile 1 çember olmalı - boyasız ve paslı çember kontrolü",
    expectedValue: "UYGUN - UYGUN DEĞİL",
  },
  {
    key: "ambalaj_durumu",
    parameter: "AMBALAJ DURUMU",
    tolerance: "Ambalaj var/yok",
    expectedValue: "VAR - YOK",
  },
];

const LOADING_CONTROL_DEFS = [
  {
    key: "konteyner_tipi",
    parameter: "KONTEYNER TİPİ",
    tolerance: "",
    expectedValue: "20'' - 40''",
  },
  {
    key: "konteyner_adet",
    parameter: "KONTEYNER ADET",
    tolerance: "Kontrol edilen konteyner sayısı",
    expectedValue: "ADET",
  },
  {
    key: "konteyner_durumu",
    parameter: "KONTEYNER DURUMU",
    tolerance: "Çevre kontrolü, delik/yırtık durumu",
    expectedValue: "UYGUN - UYGUN DEĞİL",
  },
  {
    key: "silika_jel",
    parameter: "SİLİKA JEL KULLANIMI (NEM ALICI) SAYI",
    tolerance: "Yükleme ve lashing talimatnamesine uygunluğu",
    expectedValue: "UYGUN - UYGUN DEĞİL",
  },
  {
    key: "tir_adet",
    parameter: "TIR ADET",
    tolerance: "Kontrol edilen tır sayısı",
    expectedValue: "ADET",
  },
  {
    key: "tir_durumu",
    parameter: "TIR DURUMU",
    tolerance: "Çevre kontrolü, delik/yırtık durumu",
    expectedValue: "UYGUN - UYGUN DEĞİL",
  },
  {
    key: "ahsap_nem_olcer",
    parameter: "AHŞAP NEM ÖLÇER",
    tolerance: "Konteyner iç - orta kısmından ölçülecek",
    expectedValue: "MAX %17",
  },
  {
    key: "lashing_durumu",
    parameter: "LASHINGE DURUMU",
    tolerance: "Kullanılan spanzet özellikleri",
    expectedValue: "UYGUN - UYGUN DEĞİL",
  },
  {
    key: "palet_takoz_durumu",
    parameter: "PALET TAKOZ DURUMU",
    tolerance: "ISPM - IPPC",
    expectedValue: "UYGUN - UYGUN DEĞİL",
  },
  {
    key: "vci_kagit_kaplama",
    parameter: "TAKOZ ÜZERİ VCI KAĞIT KAPLAMA",
    tolerance: "Takoz üzeri VCI ambalaj kağıdı ile kaplanmış mı?",
    expectedValue: "VAR - YOK",
  },
  {
    key: "lashing_takoz_destegi",
    parameter: "LASHINGE OLARAK TAKOZ DESTEĞİ",
    tolerance: "Yükleme ve lashing talimatnamesine uygunluğu",
    expectedValue: "UYGUN - UYGUN DEĞİL",
  },
];

const VISUAL_CONTROL_DEFS = [
  {
    key: "urun_genel_gorunum",
    parameter: "ÜRÜNLERİN GENEL GÖRÜNÜMLERİ",
    tolerance: "Aparat üzerindeki genel görüntü",
  },
  {
    key: "etiket_gorseli",
    parameter: "ETİKET GÖRSELİ",
    tolerance: "Etiket net okunur şekilde",
  },
  {
    key: "bos_konteyner_tir",
    parameter: "BOŞ KONTEYNER / TIR",
    tolerance: "Genel görünüm",
  },
  {
    key: "dolu_konteyner_tir",
    parameter: "DOLU KONTEYNER / TIR",
    tolerance: "Genel görünüm",
  },
  {
    key: "nem_alicilar",
    parameter: "NEM ALICILAR",
    tolerance: "Genel görünüm",
  },
  {
    key: "lashing_son_hali",
    parameter: "LASHINGE SON HALİ",
    tolerance: "Genel görünüm",
  },
  {
    key: "isil_islem_damgalari",
    parameter: "ISIL İŞLEM DAMGALARI",
    tolerance: "Net okunur şekilde - ön takozlarda da görülmeli",
  },
  {
    key: "hasar_gorselleri",
    parameter: "HASAR VARSA GÖRSELLER",
    tolerance: "Genel görünüm",
  },
  {
    key: "takoz_gorselleri",
    parameter: "TAKOZ GÖRSELLERİ",
    tolerance: "Genel görünüm",
  },
];

const COLORS = {
  TITLE_BG: "FF1F4E78",
  SECTION_BG: "FF2E5C8A",
  HEADER_BG: "FFD9E2F3",
  WHITE: "FFFFFFFF",
  BLACK: "FF000000",
  SUITABLE_BG: "FFE2EFDA",
  UNSUITABLE_BG: "FFFCE4E4",
};

const THIN_BORDER = {
  top: { style: "thin", color: { argb: COLORS.BLACK } },
  bottom: { style: "thin", color: { argb: COLORS.BLACK } },
  left: { style: "thin", color: { argb: COLORS.BLACK } },
  right: { style: "thin", color: { argb: COLORS.BLACK } },
};

function getStatusLabel(status) {
  switch (status) {
    case "KANTAR_CAPTURED":
      return "Kantardan Geldi";
    case "FORM_IN_PROGRESS":
      return "Form Devam Ediyor";
    case "COMPLETED":
      return "Tamamlandı";
    case "CANCELLED":
      return "İptal";
    default:
      return status || "-";
  }
}

function normalizeText(value) {
  return String(value ?? "").trim();
}

function findRow(rows, key) {
  return (Array.isArray(rows) ? rows : []).find((item) => item?.key === key) || {};
}

function splitDateTime(tarih) {
  const value = normalizeText(tarih);
  const match = value.match(/^(\d{2}\.\d{2}\.\d{4})[T\s]+(\d{2}:\d{2}(:\d{2})?)/);

  if (match) {
    return { date: match[1], time: match[2] };
  }

  return { date: value, time: "" };
}

function sanitizeForFilename(value) {
  const cleaned = String(value ?? "")
    .trim()
    .replace(/[\\/:*?"<>|]/g, "-")
    .replace(/\s+/g, " ")
    .trim();

  return cleaned || "-";
}

function formatDateForFilename(dateInput) {
  const date = dateInput ? new Date(dateInput) : new Date();

  if (Number.isNaN(date.getTime())) {
    return formatDateForFilename(new Date());
  }

  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();

  return `${dd}-${mm}-${yyyy}`;
}

export function buildYuklemeKontrolBaseName(record) {
  const tarih = formatDateForFilename(
    record?.createdAt || record?.loadingControlForm?.formHeader?.tarih
  );
  const konteynerNo = sanitizeForFilename(record?.konteynerNo);
  const musteri = sanitizeForFilename(
    record?.firmaAdi || record?.loadingControlForm?.formHeader?.musteri
  );

  return `${tarih}-${konteynerNo}-${musteri}`;
}

export function buildYuklemeKontrolFileName(record) {
  return `${buildYuklemeKontrolBaseName(record)}.xlsx`;
}

function getBackendAssetUrl(fileUrl) {
  if (!fileUrl) return "";

  if (fileUrl.startsWith("http://") || fileUrl.startsWith("https://")) {
    return fileUrl;
  }

  const baseURL = customerApi?.defaults?.baseURL || "";

  const backendOrigin = baseURL.includes("/api/")
    ? baseURL.split("/api/")[0]
    : baseURL.replace(/\/+$/, "");

  return `${backendOrigin.replace(/\/+$/, "")}${
    fileUrl.startsWith("/") ? fileUrl : `/${fileUrl}`
  }`;
}

function guessPhotoExtension(fileUrl) {
  const match = String(fileUrl || "").match(/\.([a-zA-Z0-9]{2,5})(?:\?|$)/);

  return match ? match[1].toLowerCase() : "jpg";
}

function photoLabel(photo) {
  return (
    photo?.cameraLabel ||
    photo?.cameraKey ||
    photo?.visualKey ||
    photo?.photoType ||
    "Fotograf"
  );
}

async function fetchAsArrayBuffer(url) {
  try {
    const res = await fetch(url, { credentials: "include" });

    if (!res.ok) return null;

    return await res.arrayBuffer();
  } catch (error) {
    return null;
  }
}

function styleTitleCell(cell, text, bg = COLORS.TITLE_BG) {
  cell.value = text;
  cell.font = { name: "Arial", bold: true, size: 13, color: { argb: COLORS.WHITE } };
  cell.alignment = { horizontal: "center", vertical: "middle" };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
  cell.border = THIN_BORDER;
}

function styleSectionCell(cell, text) {
  cell.value = text;
  cell.font = { name: "Arial", bold: true, size: 11, color: { argb: COLORS.WHITE } };
  cell.alignment = { horizontal: "left", vertical: "middle" };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: COLORS.SECTION_BG } };
  cell.border = THIN_BORDER;
}

function styleHeaderCell(cell, text) {
  cell.value = text;
  cell.font = { name: "Arial", bold: true, size: 10 };
  cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: COLORS.HEADER_BG } };
  cell.border = THIN_BORDER;
}

function styleLabelCell(cell, text) {
  cell.value = text;
  cell.font = { name: "Arial", bold: true, size: 10 };
  cell.alignment = { horizontal: "left", vertical: "middle" };
  cell.border = THIN_BORDER;
}

function styleValueCell(cell, value, opts = {}) {
  cell.value = value ?? "";
  cell.font = { name: "Arial", bold: !!opts.bold, size: 10 };
  cell.alignment = {
    horizontal: opts.align || "left",
    vertical: "middle",
    wrapText: true,
  };
  cell.border = THIN_BORDER;

  if (opts.bg) {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: opts.bg } };
  }
}

function suitabilityBg(observation) {
  const text = normalizeText(observation).toLocaleUpperCase("tr-TR");

  if (!text) return null;

  if (text.includes("UYGUN DEĞİL") || text.includes("UYGUN DEGIL")) {
    return COLORS.UNSUITABLE_BG;
  }

  return COLORS.SUITABLE_BG;
}

function visualStatusBg(status) {
  const text = normalizeText(status).toLocaleUpperCase("tr-TR");

  if (text === "RESİM ALINDI" || text === "RESIM ALINDI") return COLORS.SUITABLE_BG;
  if (text === "RESİM ALINMADI" || text === "RESIM ALINMADI") return COLORS.UNSUITABLE_BG;

  return null;
}

function addControlSection(ws, title, defs, rows, extraColumnLabel) {
  const sectionRow = ws.addRow([title]);
  ws.mergeCells(sectionRow.number, 1, sectionRow.number, 8);
  styleSectionCell(sectionRow.getCell(1), title);
  for (let col = 2; col <= 8; col++) {
    sectionRow.getCell(col).border = THIN_BORDER;
  }

  const headerRow = ws.addRow([
    "Parametre",
    "Açıklama / Tolerans Limitleri",
    "",
    "",
    "Beklenen Değer",
    "Gözlem / Açıklama",
    "",
    extraColumnLabel,
  ]);
  ws.mergeCells(headerRow.number, 2, headerRow.number, 4);
  ws.mergeCells(headerRow.number, 6, headerRow.number, 7);
  headerRow.eachCell((cell) => styleHeaderCell(cell, cell.value || ""));

  defs.forEach((def) => {
    const found = findRow(rows, def.key);
    const observation = normalizeText(found.observation);
    const extraValue = normalizeText(found.labelNo || found.containerNo);

    const row = ws.addRow([
      def.parameter,
      def.tolerance,
      "",
      "",
      def.expectedValue,
      observation,
      "",
      extraValue,
    ]);
    ws.mergeCells(row.number, 2, row.number, 4);
    ws.mergeCells(row.number, 6, row.number, 7);

    styleLabelCell(row.getCell(1), def.parameter);
    styleValueCell(row.getCell(2), def.tolerance);
    styleValueCell(row.getCell(5), def.expectedValue, { align: "center" });
    styleValueCell(row.getCell(6), observation, {
      align: "center",
      bold: true,
      bg: suitabilityBg(observation),
    });
    styleValueCell(row.getCell(8), extraValue, { align: "center" });

    for (let col = 1; col <= 8; col++) {
      row.getCell(col).border = THIN_BORDER;
    }
  });
}

function addVisualSection(ws, rows) {
  const sectionRow = ws.addRow(["GÖRÜNTÜ ALINACAK BİLGİLER"]);
  ws.mergeCells(sectionRow.number, 1, sectionRow.number, 8);
  styleSectionCell(sectionRow.getCell(1), "GÖRÜNTÜ ALINACAK BİLGİLER");
  for (let col = 2; col <= 8; col++) {
    sectionRow.getCell(col).border = THIN_BORDER;
  }

  const headerRow = ws.addRow([
    "Parametre",
    "Açıklama",
    "",
    "",
    "Limit",
    "Resim Alındı",
    "",
    "",
  ]);
  ws.mergeCells(headerRow.number, 2, headerRow.number, 4);
  ws.mergeCells(headerRow.number, 6, headerRow.number, 7);
  headerRow.eachCell((cell) => styleHeaderCell(cell, cell.value || ""));

  VISUAL_CONTROL_DEFS.forEach((def) => {
    const found = findRow(rows, def.key);
    const status = normalizeText(found.status) || "RESİM ALINMADI";
    const note = normalizeText(found.note);

    const row = ws.addRow([
      def.parameter,
      def.tolerance,
      "",
      "",
      "min 2 görsel",
      status,
      "",
      note,
    ]);
    ws.mergeCells(row.number, 2, row.number, 4);
    ws.mergeCells(row.number, 6, row.number, 7);

    styleLabelCell(row.getCell(1), def.parameter);
    styleValueCell(row.getCell(2), def.tolerance);
    styleValueCell(row.getCell(5), "min 2 görsel", { align: "center" });
    styleValueCell(row.getCell(6), status, {
      align: "center",
      bold: true,
      bg: visualStatusBg(status),
    });
    styleValueCell(row.getCell(8), note, { align: "center" });

    for (let col = 1; col <= 8; col++) {
      row.getCell(col).border = THIN_BORDER;
    }
  });
}

export async function buildYuklemeKontrolWorkbook(record) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Yükleme Kontrol", {
    properties: { defaultRowHeight: 20 },
  });

  ws.columns = [
    { width: 32 },
    { width: 14 },
    { width: 14 },
    { width: 16 },
    { width: 22 },
    { width: 14 },
    { width: 14 },
    { width: 30 },
  ];

  const form = record?.loadingControlForm || {};
  const header = form.formHeader || {};
  const general = form.generalSection || {};
  const populatedOwner = record?.createdBy;
  const ownerName =
    normalizeText(record?.createdByName) ||
    (populatedOwner && typeof populatedOwner === "object"
      ? normalizeText(`${populatedOwner?.name || ""} ${populatedOwner?.surname || ""}`) ||
        normalizeText(populatedOwner?.email)
      : "") ||
    normalizeText(general.controlUser);
  const { date: tarihDate, time: tarihSaat } = splitDateTime(header.tarih);

  const titleRow = ws.addRow(["YÜKLEME KONTROL FORMU"]);
  ws.mergeCells(titleRow.number, 1, titleRow.number, 5);
  styleTitleCell(titleRow.getCell(1), "YÜKLEME KONTROL FORMU");
  for (let col = 2; col <= 5; col++) titleRow.getCell(col).border = THIN_BORDER;

  styleValueCell(titleRow.getCell(6), "Form No:", { bold: true, align: "right" });
  styleValueCell(titleRow.getCell(7), normalizeText(header.formNo) || "PR07-FR24", {
    align: "center",
  });
  ws.mergeCells(titleRow.number, 8, titleRow.number, 8);

  const revRow = ws.addRow(["", "", "", "", "", "Revizyon No / Tarihi:", "", ""]);
  ws.mergeCells(revRow.number, 1, revRow.number, 5);
  revRow.getCell(1).border = THIN_BORDER;
  styleValueCell(revRow.getCell(6), "Revizyon No / Tarihi:", {
    bold: true,
    align: "right",
  });
  styleValueCell(
    revRow.getCell(7),
    `${normalizeText(header.revisionNo) || "1"} / ${normalizeText(header.revisionDate) || "-"}`,
    { align: "center" }
  );
  ws.mergeCells(revRow.number, 7, revRow.number, 8);

  const infoRow1 = ws.addRow([
    "KONTEYNER NO",
    normalizeText(record?.konteynerNo) || "-",
    "",
    "FİRMA ADI",
    normalizeText(record?.firmaAdi) || "-",
    "",
    "DURUM",
    getStatusLabel(record?.status),
  ]);
  ws.mergeCells(infoRow1.number, 2, infoRow1.number, 3);
  ws.mergeCells(infoRow1.number, 5, infoRow1.number, 6);
  styleLabelCell(infoRow1.getCell(1), "KONTEYNER NO");
  styleValueCell(infoRow1.getCell(2), normalizeText(record?.konteynerNo) || "-", {
    bold: true,
    align: "center",
  });
  styleLabelCell(infoRow1.getCell(4), "FİRMA ADI");
  styleValueCell(infoRow1.getCell(5), normalizeText(record?.firmaAdi) || "-", {
    bold: true,
    align: "center",
  });
  styleLabelCell(infoRow1.getCell(7), "DURUM");
  styleValueCell(infoRow1.getCell(8), getStatusLabel(record?.status), {
    bold: true,
    align: "center",
  });
  infoRow1.eachCell((cell) => (cell.border = THIN_BORDER));

  const infoRow2 = ws.addRow([
    "TARİH",
    tarihDate || "-",
    "SAAT",
    tarihSaat || "-",
    "EBAT",
    normalizeText(header.ebat) || "-",
    "",
    "",
  ]);
  ws.mergeCells(infoRow2.number, 5, infoRow2.number, 8);
  styleLabelCell(infoRow2.getCell(1), "TARİH");
  styleValueCell(infoRow2.getCell(2), tarihDate || "-", { align: "center" });
  styleLabelCell(infoRow2.getCell(3), "SAAT");
  styleValueCell(infoRow2.getCell(4), tarihSaat || "-", { align: "center" });
  styleLabelCell(infoRow2.getCell(5), "EBAT");
  styleValueCell(infoRow2.getCell(6), normalizeText(header.ebat) || "-", {
    align: "center",
  });
  infoRow2.eachCell((cell) => (cell.border = THIN_BORDER));

  const infoRow3 = ws.addRow([
    "MALZEME CİNSİ",
    normalizeText(header.malzemeCinsi) || "-",
    "",
    "MÜŞTERİ",
    normalizeText(header.musteri) || "-",
    "",
    "LOT NO",
    normalizeText(header.lotNo) || "-",
  ]);
  ws.mergeCells(infoRow3.number, 2, infoRow3.number, 3);
  ws.mergeCells(infoRow3.number, 5, infoRow3.number, 6);
  styleLabelCell(infoRow3.getCell(1), "MALZEME CİNSİ");
  styleValueCell(infoRow3.getCell(2), normalizeText(header.malzemeCinsi) || "-");
  styleLabelCell(infoRow3.getCell(4), "MÜŞTERİ");
  styleValueCell(infoRow3.getCell(5), normalizeText(header.musteri) || "-");
  styleLabelCell(infoRow3.getCell(7), "LOT NO");
  styleValueCell(infoRow3.getCell(8), normalizeText(header.lotNo) || "-", {
    align: "center",
  });
  infoRow3.eachCell((cell) => (cell.border = THIN_BORDER));

  const infoRow4 = ws.addRow([
    "REF NO",
    normalizeText(header.refNo) || "-",
    "",
    "İRSALİYE NO",
    normalizeText(record?.irsaliyeNo) || "-",
    "",
    "",
    "",
  ]);
  ws.mergeCells(infoRow4.number, 2, infoRow4.number, 3);
  ws.mergeCells(infoRow4.number, 5, infoRow4.number, 8);
  styleLabelCell(infoRow4.getCell(1), "REF NO");
  styleValueCell(infoRow4.getCell(2), normalizeText(header.refNo) || "-", {
    align: "center",
  });
  styleLabelCell(infoRow4.getCell(4), "İRSALİYE NO");
  styleValueCell(infoRow4.getCell(5), normalizeText(record?.irsaliyeNo) || "-");
  infoRow4.eachCell((cell) => (cell.border = THIN_BORDER));

  if (normalizeText(record?.note)) {
    const noteRow = ws.addRow(["NOT", normalizeText(record?.note), "", "", "", "", "", ""]);
    ws.mergeCells(noteRow.number, 2, noteRow.number, 8);
    styleLabelCell(noteRow.getCell(1), "NOT");
    styleValueCell(noteRow.getCell(2), normalizeText(record?.note));
    noteRow.eachCell((cell) => (cell.border = THIN_BORDER));
  }

  ws.addRow([]);

  addControlSection(
    ws,
    "KONTROL EDİLECEK PARAMETRELER - ÜRÜN",
    PRODUCT_CONTROL_DEFS,
    form.productControls,
    "Etiket No / Açıklama"
  );

  ws.addRow([]);

  addControlSection(
    ws,
    "KONTROL EDİLECEK PARAMETRELER - YÜKLEME",
    LOADING_CONTROL_DEFS,
    form.loadingControls,
    "Konteyner No / Açıklama"
  );

  ws.addRow([]);

  addVisualSection(ws, form.visualControls);

  ws.addRow([]);

  const generalSectionRow = ws.addRow(["GENEL GÖZLEMLER"]);
  ws.mergeCells(generalSectionRow.number, 1, generalSectionRow.number, 8);
  styleSectionCell(generalSectionRow.getCell(1), "GENEL GÖZLEMLER");
  for (let col = 2; col <= 8; col++) generalSectionRow.getCell(col).border = THIN_BORDER;

  const observationsRow = ws.addRow([
    normalizeText(general.generalObservations) || "-",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  ws.mergeCells(observationsRow.number, 1, observationsRow.number, 8);
  styleValueCell(
    observationsRow.getCell(1),
    normalizeText(general.generalObservations) || "-"
  );
  observationsRow.eachCell((cell) => (cell.border = THIN_BORDER));

  const summaryRow1 = ws.addRow([
    "UYGUNLUK SEVİYESİ",
    normalizeText(general.suitabilityLevel) || "-",
    "",
    "TOPLAM PARAMETRE SAYISI",
    general.totalParameterCount ?? 0,
    "UYGUN OLAN PARAMETRE SAYISI",
    "",
    general.suitableParameterCount ?? 0,
  ]);
  ws.mergeCells(summaryRow1.number, 2, summaryRow1.number, 3);
  ws.mergeCells(summaryRow1.number, 6, summaryRow1.number, 7);
  styleLabelCell(summaryRow1.getCell(1), "UYGUNLUK SEVİYESİ");
  styleValueCell(summaryRow1.getCell(2), normalizeText(general.suitabilityLevel) || "-", {
    align: "center",
  });
  styleLabelCell(summaryRow1.getCell(4), "TOPLAM PARAMETRE SAYISI");
  styleValueCell(summaryRow1.getCell(5), general.totalParameterCount ?? 0, {
    align: "center",
    bold: true,
  });
  styleLabelCell(summaryRow1.getCell(6), "UYGUN OLAN PARAMETRE SAYISI");
  styleValueCell(summaryRow1.getCell(8), general.suitableParameterCount ?? 0, {
    align: "center",
    bold: true,
  });
  summaryRow1.eachCell((cell) => (cell.border = THIN_BORDER));

  const summaryRow2 = ws.addRow([
    "KALİTE İNDEKSİ",
    `${general.qualityIndex ?? 0}%`,
    "",
    "KONTROL EDEN",
    ownerName || "-",
    "ONAYLAYAN",
    "",
    normalizeText(general.approvalUser) || "-",
  ]);
  ws.mergeCells(summaryRow2.number, 2, summaryRow2.number, 3);
  ws.mergeCells(summaryRow2.number, 6, summaryRow2.number, 7);
  styleLabelCell(summaryRow2.getCell(1), "KALİTE İNDEKSİ");
  styleValueCell(summaryRow2.getCell(2), `${general.qualityIndex ?? 0}%`, {
    align: "center",
    bold: true,
  });
  styleLabelCell(summaryRow2.getCell(4), "KONTROL EDEN");
  styleValueCell(summaryRow2.getCell(5), ownerName || "-", {
    align: "center",
  });
  styleLabelCell(summaryRow2.getCell(6), "ONAYLAYAN");
  styleValueCell(summaryRow2.getCell(8), normalizeText(general.approvalUser) || "-", {
    align: "center",
  });
  summaryRow2.eachCell((cell) => (cell.border = THIN_BORDER));

  ws.eachRow((row) => {
    row.eachCell({ includeEmpty: false }, (cell) => {
      if (!cell.font) cell.font = { name: "Arial", size: 10 };
    });
  });

  return wb;
}

export async function exportYuklemeKontrolExcel(record) {
  const wb = await buildYuklemeKontrolWorkbook(record);
  const buffer = await wb.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    buildYuklemeKontrolFileName(record)
  );
}

export async function downloadSelectedYuklemeKontrolAsZip(records, onProgress) {
  const list = Array.isArray(records) ? records : [];

  if (!list.length) return;

  const zip = new JSZip();

  for (let i = 0; i < list.length; i++) {
    const record = list[i];
    const baseName = buildYuklemeKontrolBaseName(record);
    const folder = zip.folder(baseName);

    if (onProgress) {
      onProgress({ kayitIndex: i + 1, kayitSayisi: list.length, asama: "excel" });
    }

    // eslint-disable-next-line no-await-in-loop
    const wb = await buildYuklemeKontrolWorkbook(record);
    // eslint-disable-next-line no-await-in-loop
    const excelBuffer = await wb.xlsx.writeBuffer();

    folder.file(`${baseName}.xlsx`, excelBuffer);

    const photos = Array.isArray(record?.photos)
      ? record.photos.filter((photo) => photo?.fileUrl)
      : [];

    if (photos.length > 0) {
      const photosFolder = folder.folder(`${baseName}-fotograflar`);

      for (let p = 0; p < photos.length; p++) {
        const photo = photos[p];

        if (onProgress) {
          onProgress({
            kayitIndex: i + 1,
            kayitSayisi: list.length,
            asama: "photo",
            fotoIndex: p + 1,
            fotoSayisi: photos.length,
          });
        }

        const url = getBackendAssetUrl(photo.fileUrl);
        // eslint-disable-next-line no-await-in-loop
        const buffer = await fetchAsArrayBuffer(url);

        if (buffer) {
          const ext = guessPhotoExtension(photo.fileUrl);
          const name = sanitizeForFilename(photoLabel(photo));

          photosFolder.file(`${String(p + 1).padStart(2, "0")}-${name}.${ext}`, buffer);
        }
      }
    }
  }

  if (onProgress) onProgress({ asama: "zip" });

  const zipBuffer = await zip.generateAsync({ type: "blob" });

  const zipName =
    list.length === 1
      ? `${buildYuklemeKontrolBaseName(list[0])}.zip`
      : `yukleme-kontrol-${formatDateForFilename(new Date())}-${list.length}-kayit.zip`;

  saveAs(zipBuffer, zipName);
}
